import type { EstateAgentDetail } from "@/api/temp/AgentEstateService";
import type {
  EstateAssetType,
  RelationshipEdge,
  RelationshipGraph,
} from "@/api/temp/TrustAIExecutiveService";

/** Only explicit fixture associations; no generated runtime or catalog relationships. */
export function demoRelationships(
  graph: RelationshipGraph,
  agents: EstateAgentDetail[],
): RelationshipGraph {
  const types: EstateAssetType[] = [
    "ai-agents",
    "mcp-servers",
    "tools",
    "data-sources",
  ];
  const nodes = graph.nodes
    .filter(node => types.includes(node.assetType))
    .map(node => ({ ...node, runtimeActive: false, violationCount: 0 }));
  const ids = new Set(nodes.map(node => node.id));
  const edges = new Map<string, RelationshipEdge>();
  const connect = (from: string, to: string) => {
    const source = `node-${from}`;
    const target = `node-${to}`;
    if (!ids.has(source) || !ids.has(target)) return;
    const id = `${source}:${target}`;
    edges.set(id, {
      id,
      source,
      target,
      runtimeActive: false,
      policyStatus: "Not evaluated",
      violationCount: 0,
    });
  };
  for (const agent of agents) {
    for (const server of agent.mcpServices) {
      connect(agent.id, server.id);
      for (const tool of server.tools) {
        connect(server.id, tool.id);
        if (tool.dataSourceId) connect(tool.id, tool.dataSourceId);
      }
    }
  }
  return {
    nodes,
    edges: [...edges.values()],
    totals: Object.fromEntries(
      Object.keys(graph.totals).map(type => [
        type,
        nodes.filter(node => node.assetType === type).length,
      ]),
    ) as RelationshipGraph["totals"],
  };
}
